import { Toast } from '@clickcease/cc-client-components-lib'
import { isToday } from 'date-fns'
import { TableRowTitle } from 'Features/home/routes/Home/types'
import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { getFormattedDate } from 'Utils/dates'
import {
  CollapsibleRowStyle,
  Divider,
  ExpandedRowHeader,
  ExpandedRowTitle,
  ExpandedRowTitleText,
  ExpandedRowTitleDate,
  NewLabel,
  ExpandedDataContainer,
  NoData,
  ThreatTypeExplanation,
} from '../Insights/InsightsTable.styled'
import { ProductType } from 'Types/InsightsRow'

type InsightsTableProp = {
  data: TableRowTitle[]
}

const PaidMarketingExpand = (row: TableRowTitle) => {
  const { t } = useTranslation('dashboard')
  const threatTypeExplanationKey = `insights_table.threat_types_explanations.${row.threatType
    .toLowerCase()
    .replace(' ', '_')}`
  const threatTypeExplanation = t(threatTypeExplanationKey)

  return (
    <>
      <Trans ns="dashboard" i18nKey="insights_table.paid_marketing_message">
        Paid Marketing: IP {{ ip: row.ip }} coming from{' '}
        {{ platform: t(`insights_table.${row.platform.toLowerCase()}`) }} was detected on{' '}
        {{ domain: row.domain }}
        at {{ timestamp: getFormattedDate(new Date(row.lastClick)) }}. The IP exhibited{' '}
        {{ threatType: row.threatType?.toLowerCase() }} behavior.
      </Trans>

      <ThreatTypeExplanation>
        {threatTypeExplanation !== threatTypeExplanationKey
          ? `${t('insights_table.explanation')} ${threatTypeExplanation}`
          : `${t(
              'insights_table.explanation'
            )} No explanation available for ${row.threatType?.toLowerCase()}.`}
      </ThreatTypeExplanation>
    </>
  )
}

export const InsightsTable = ({ data }: InsightsTableProp) => {
  const { t } = useTranslation('dashboard')

  return (
    <>
      {!data?.length && (
        <NoData>
          <Toast type="info">{t('no_insights')}</Toast>
        </NoData>
      )}
      {data.map((row, key) => {
        const application =
          row.application === 0 ? ProductType.BOTZAPPING : ProductType.PAID_MARKETING
        if (application === ProductType.BOTZAPPING) return <></>
        return (
          <CollapsibleRowStyle
            key={`row_${row.domain}_${key}_${row.lastClick}`}
            visibleContent={
              <ExpandedRowHeader>
                <ExpandedRowTitle>
                  <ExpandedRowTitleDate>
                    {getFormattedDate(new Date(row.lastClick))}
                  </ExpandedRowTitleDate>
                  <Divider />
                  <ExpandedRowTitleText>
                    {t(`overall_domain_performance.${application}`)}: {row.threatType} detected on{' '}
                    {row.domain}
                  </ExpandedRowTitleText>
                </ExpandedRowTitle>
                {isToday(new Date(row.lastClick)) && <NewLabel>New</NewLabel>}
              </ExpandedRowHeader>
            }
            collapsableContent={
              <ExpandedDataContainer>
                <PaidMarketingExpand {...row} />
              </ExpandedDataContainer>
            }
            triggerCellFlex={0.01}
          />
        )
      })}
    </>
  )
}
